/**
 * @generated SignedSource<<57e149fed52beaa70759234c2ae4bbb7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DatasetContentScaffoldVersionQuery$variables = {
  major: number;
  minor: number;
  owner: string;
  patch: number;
  slug: string;
};
export type DatasetContentScaffoldVersionQuery$data = {
  readonly datasetBySlug: {
    readonly id: string;
    readonly version: {
      readonly analytics: {
        readonly " $fragmentSpreads": FragmentRefs<"DatasetAnalyticsFragment">;
      };
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"DatasetVersionAsideContentFragment">;
    } | null | undefined;
    readonly votes: number;
  } | null | undefined;
};
export type DatasetContentScaffoldVersionQuery = {
  response: DatasetContentScaffoldVersionQuery$data;
  variables: DatasetContentScaffoldVersionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "major"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "minor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "owner"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "patch"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v5 = [
  {
    "kind": "Variable",
    "name": "localSlug",
    "variableName": "slug"
  },
  {
    "kind": "Variable",
    "name": "owner",
    "variableName": "owner"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votes",
  "storageKey": null
},
v8 = [
  {
    "kind": "Variable",
    "name": "major",
    "variableName": "major"
  },
  {
    "kind": "Variable",
    "name": "minor",
    "variableName": "minor"
  },
  {
    "kind": "Variable",
    "name": "patch",
    "variableName": "patch"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedAt",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = [
  (v6/*:: as any*/),
  (v9/*:: as any*/)
],
v13 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageThumbnail",
  "storageKey": null
},
v20 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  }
],
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DatasetContentScaffoldVersionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*:: as any*/),
        "concreteType": "Dataset",
        "kind": "LinkedField",
        "name": "datasetBySlug",
        "plural": false,
        "selections": [
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          {
            "alias": null,
            "args": (v8/*:: as any*/),
            "concreteType": "DatasetVersion",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              (v6/*:: as any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "DatasetVersionAsideContentFragment"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DatasetAnalytics",
                "kind": "LinkedField",
                "name": "analytics",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "DatasetAnalyticsFragment"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*:: as any*/),
      (v4/*:: as any*/),
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "DatasetContentScaffoldVersionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*:: as any*/),
        "concreteType": "Dataset",
        "kind": "LinkedField",
        "name": "datasetBySlug",
        "plural": false,
        "selections": [
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          {
            "alias": null,
            "args": (v8/*:: as any*/),
            "concreteType": "DatasetVersion",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              (v6/*:: as any*/),
              (v9/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "license",
                "storageKey": null
              },
              (v10/*:: as any*/),
              {
                "alias": "viewerCanUpdate",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "action",
                    "value": "UPDATE_DATASET_VERSION"
                  }
                ],
                "kind": "ScalarField",
                "name": "viewerCan",
                "storageKey": "viewerCan(action:\"UPDATE_DATASET_VERSION\")"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DOI",
                "kind": "LinkedField",
                "name": "doi",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "full",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "short",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Dataset",
                "kind": "LinkedField",
                "name": "dataset",
                "plural": false,
                "selections": [
                  (v6/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  },
                  (v11/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "shortDescription",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "private",
                    "storageKey": null
                  },
                  {
                    "alias": "viewerCanUpdate",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "action",
                        "value": "UPDATE_DATASET"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "viewerCan",
                    "storageKey": "viewerCan(action:\"UPDATE_DATASET\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DatasetVersion",
                    "kind": "LinkedField",
                    "name": "latestVersion",
                    "plural": false,
                    "selections": (v12/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": "latestCreatedVersion",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                      }
                    ],
                    "concreteType": "DatasetVersionConnection",
                    "kind": "LinkedField",
                    "name": "versions",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DatasetVersion",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": (v12/*:: as any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": "versions(first:1)"
                  },
                  {
                    "alias": "versionsInput",
                    "args": (v13/*:: as any*/),
                    "concreteType": "DatasetVersionConnection",
                    "kind": "LinkedField",
                    "name": "versions",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DatasetVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DatasetVersion",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*:: as any*/),
                              (v9/*:: as any*/),
                              (v10/*:: as any*/),
                              (v14/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v15/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v16/*:: as any*/)
                    ],
                    "storageKey": "versions(first:20)"
                  },
                  {
                    "alias": "versionsInput",
                    "args": (v13/*:: as any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "DatasetVersionCreateButtonFragment_versionsInput",
                    "kind": "LinkedHandle",
                    "name": "versions"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "owner",
                    "plural": false,
                    "selections": [
                      (v14/*:: as any*/),
                      (v17/*:: as any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isEntity"
                      },
                      (v18/*:: as any*/),
                      (v19/*:: as any*/),
                      (v6/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": "tagList",
                        "args": (v20/*:: as any*/),
                        "concreteType": "TaggableConnection",
                        "kind": "LinkedField",
                        "name": "tags",
                        "plural": false,
                        "selections": [
                          (v21/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TagEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Tag",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v6/*:: as any*/),
                                  (v11/*:: as any*/),
                                  (v14/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v15/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v16/*:: as any*/)
                        ],
                        "storageKey": "tags(first:5)"
                      },
                      {
                        "alias": "tagList",
                        "args": (v20/*:: as any*/),
                        "filters": null,
                        "handle": "connection",
                        "key": "TagListFragment_tagList",
                        "kind": "LinkedHandle",
                        "name": "tags"
                      }
                    ],
                    "type": "Taggable",
                    "abstractKey": "__isTaggable"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "size",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "publishable",
                "storageKey": null
              },
              {
                "alias": "viewerCanPublishDatasetVersion",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "action",
                    "value": "PUBLISH_DATASET_VERSION"
                  }
                ],
                "kind": "ScalarField",
                "name": "viewerCan",
                "storageKey": "viewerCan(action:\"PUBLISH_DATASET_VERSION\")"
              },
              {
                "alias": "authorsPreview",
                "args": (v20/*:: as any*/),
                "concreteType": "DatasetVersionAuthorConnection",
                "kind": "LinkedField",
                "name": "authors",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DatasetVersionAuthorConnectionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v15/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v14/*:: as any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v6/*:: as any*/),
                              (v17/*:: as any*/),
                              (v18/*:: as any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v19/*:: as any*/)
                                ],
                                "type": "Entity",
                                "abstractKey": "__isEntity"
                              }
                            ],
                            "type": "User",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "fullName",
                                "storageKey": null
                              }
                            ],
                            "type": "UnregisteredUser",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v6/*:: as any*/)
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v16/*:: as any*/)
                ],
                "storageKey": "authors(first:5)"
              },
              {
                "alias": "authorsPreview",
                "args": (v20/*:: as any*/),
                "filters": null,
                "handle": "connection",
                "key": "DatasetVersionAsideContentAuthorsFragment_authorsPreview",
                "kind": "LinkedHandle",
                "name": "authors"
              },
              {
                "alias": "authorsCount",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 0
                  }
                ],
                "concreteType": "DatasetVersionAuthorConnection",
                "kind": "LinkedField",
                "name": "authors",
                "plural": false,
                "selections": [
                  (v21/*:: as any*/)
                ],
                "storageKey": "authors(first:0)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DatasetAnalytics",
                "kind": "LinkedField",
                "name": "analytics",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rowCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fileSize",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "downloadCount",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "52719b59f54c0127717678de02859b39",
    "id": null,
    "metadata": {},
    "name": "DatasetContentScaffoldVersionQuery",
    "operationKind": "query",
    "text": "query DatasetContentScaffoldVersionQuery(\n  $owner: String!\n  $slug: String!\n  $major: Int!\n  $minor: Int!\n  $patch: Int!\n) {\n  datasetBySlug(owner: $owner, localSlug: $slug) {\n    id\n    votes\n    version(major: $major, minor: $minor, patch: $patch) {\n      id\n      ...DatasetVersionAsideContentFragment\n      analytics {\n        ...DatasetAnalyticsFragment\n      }\n    }\n  }\n}\n\nfragment DatasetAnalyticsFragment on DatasetAnalytics {\n  rowCount\n  fileSize\n  downloadCount\n}\n\nfragment DatasetDOIFragment on DatasetVersion {\n  id\n  doi {\n    full\n    short\n    url\n  }\n}\n\nfragment DatasetVersionAsideContentAuthorsFragment on DatasetVersion {\n  authorsPreview: authors(first: 5) {\n    edges {\n      cursor\n      node {\n        __typename\n        ... on User {\n          id\n          username\n          displayName\n          ...EntityProfilePicFragment_49kWkb\n        }\n        ... on UnregisteredUser {\n          fullName\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment DatasetVersionAsideContentFragment on DatasetVersion {\n  id\n  version\n  license\n  publishedAt\n  viewerCanUpdate: viewerCan(action: UPDATE_DATASET_VERSION)\n  doi {\n    full\n  }\n  dataset {\n    id\n    slug\n    name\n    shortDescription\n    private\n    viewerCanUpdate: viewerCan(action: UPDATE_DATASET)\n    ...TagListFragment\n    ...DatasetVersionCreateButtonFragment\n  }\n  ...DatasetVersionCardFragment\n  ...DatasetVersionEditSheet\n  ...DatasetVersionAsideContentAuthorsFragment\n  ...DatasetDOIFragment\n  authorsCount: authors(first: 0) {\n    totalCount\n  }\n}\n\nfragment DatasetVersionCardFragment on DatasetVersion {\n  id\n  version\n  size\n  publishedAt\n  createdAt\n  updatedAt\n  dataset {\n    id\n    slug\n    owner {\n      __typename\n      username\n      ...EntityProfilePicFragment_49kWkb\n      id\n    }\n  }\n  ...DatasetVersionPublishButtonFragment\n}\n\nfragment DatasetVersionCreateButtonFragment on Dataset {\n  id\n  latestVersion {\n    id\n    version\n  }\n  latestCreatedVersion: versions(first: 1) {\n    nodes {\n      id\n      version\n    }\n  }\n  versionsInput: versions(first: 20) {\n    edges {\n      node {\n        id\n        version\n        publishedAt\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment DatasetVersionEditSheet on DatasetVersion {\n  id\n  version\n  dataset {\n    slug\n    id\n  }\n}\n\nfragment DatasetVersionPublishButtonFragment on DatasetVersion {\n  id\n  version\n  publishable @ifAllowed\n  viewerCanPublishDatasetVersion: viewerCan(action: PUBLISH_DATASET_VERSION)\n}\n\nfragment EntityProfilePicFragment_49kWkb on Entity {\n  __isEntity: __typename\n  displayName\n  imageThumbnail\n}\n\nfragment TagFragment on Tag {\n  name\n}\n\nfragment TagListFragment on Taggable {\n  __isTaggable: __typename\n  tagList: tags(first: 5) {\n    totalCount\n    edges {\n      node {\n        id\n        ...TagFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "3194b2e10cc2cc4c9acbbea84638640d";

export default node;
